import { render, staticRenderFns } from "./genexMiniLoader.vue?vue&type=template&id=50bd0842&scoped=true&"
import script from "./genexMiniLoader.vue?vue&type=script&lang=js&"
export * from "./genexMiniLoader.vue?vue&type=script&lang=js&"
import style0 from "./genexMiniLoader.vue?vue&type=style&index=0&id=50bd0842&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bd0842",
  null
  
)

export default component.exports